import type { MegaStore } from '../stores/megaStore'
import { getTemplateIdAndItemContext } from './repeatersAPI'
import type { CatharsisArgs } from '../types/catharsis.types'
import { COMPS_ROOT_NAMESPACE } from '../refs/constants'

export const getInvalidationHandler = (megaStore: MegaStore): CatharsisArgs['onInvalidation'] => (path, get) => {
	const [namespace, aspect, id] = path

	if (namespace !== COMPS_ROOT_NAMESPACE) {
		return
	}

	const [compId, context] = getTemplateIdAndItemContext(id)

	if (
		!(process.env.PACKAGE_NAME === 'thunderbolt-app' || process.env.PACKAGE_NAME === 'thunderbolt-ds') ||
		aspect === 'componentCss' ||
		aspect === 'compCssMappers'
	) {
		const aspectStore = megaStore.getChildStore(aspect)
		const contextStore = context ? aspectStore.getChildStore(context) : aspectStore

		contextStore.updateById(compId, get(path))
	}

	if (aspect === 'fontFamilies' || aspect === 'fontFacesCss') {
		const aspectStore = megaStore.getChildStore(aspect)
		aspectStore.updateById(id, get(path))
	}
}
